import { Tooltip } from "@fluentui/react-components";
import PropTypes from "prop-types";
import * as React from "react";

const CommonTooltip = React.forwardRef(function CommonTooltip(props, ref) {
  const showDelay = props.showDelay ?? 2000;
  const relationship = props.relationship ?? "label";
  const hideDelay = props.hideDelay ?? 300;
  const positioning = props.positioning ?? "before";
  return (
    <Tooltip
      {...props}
      showDelay={showDelay}
      hideDelay={hideDelay}
      positioning={positioning}
      relationship={relationship}
      ref={ref}
    />
  );
});

CommonTooltip.propTypes = {
  showDelay: PropTypes.number,
  hideDelay: PropTypes.number,
  relationship: PropTypes.string,
  positioning: PropTypes.string,
};

export default CommonTooltip;
